var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":(_vm.serviceType + "-online-drivers-without-trips"),"title":"Online Drivers"}},[_c('b-table',{attrs:{"responsive":"","fields":_vm.columns,"items":_vm.tableData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }